import * as React from 'react'
import { LoaderComponent } from 'Modules'

export const SuspenseComponent: React.FC = ({ children }): JSX.Element => {
	return <React.Suspense fallback={<LoaderComponent isVisible />}>{children}</React.Suspense>
}
